var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackAndSupportFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#784ace;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feedback_and_support_feedback"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301,1C136.23,1,2.43,133.6,1,298.36A298.73,298.73,0,0,0,36.55,442.74a30.19,30.19,0,0,1,2.23,23.48L3.59,576.1A18.64,18.64,0,0,0,27,599.53L137.5,564.15a30.13,30.13,0,0,1,23.32,2.14A300.08,300.08,0,0,0,601,301C601,135.31,466.69,1,301,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.7,
    y: 328.45,
    width: 342.5,
    height: 93.62,
    rx: 46.81,
    transform: "translate(-2.84 2.3) rotate(-0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 129.35,
    y: 179.54,
    width: 342.64,
    height: 93.62,
    rx: 46.81,
    transform: "translate(-1.71 2.29) rotate(-0.43)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackAndSupportFeedback);
export default __webpack_public_path__ + "static/media/feedback_and_support_feedback.7c37f97e7cbacc0ece012b689f14440b.svg";
export { ForwardRef as ReactComponent };